export interface TaActionTypes {
  type: TaActions;
  payload?: any;
}

export enum TaActions {
  CREATE_TA = "CREATE_TA",
  GET_TA_LIST = "GET_TA_LIST",
  SET_TA_LIST = "SET_TA_LIST",
  SET_TA_LIST_PAGE_COUNT = "SET_TA_LIST_PAGE_COUNT",
  GET_TA_DATA_BY_ID = "GET_TA_DATA_BY_ID",
  SET_TA_DATA_BY_ID = "SET_TA_DATA_BY_ID",
  EDIT_TA_DATA_BY_ID = "EDIT_TA_DATA_BY_ID",
}
